import { worker } from './browser'

export function startWorker () {
  worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js'
    }
  })
}
